// Core demand CRUD + stage transitions (/api/demands).
//
// Several screens were hand-rolling these fetches: DemandDashboard called
// '/api/demands/list' and '/api/demands/stats/summary' directly, RequirementsPage
// used an absolute 'http://localhost:8000/api/demands/list', and TriageUI fetched
// '/api/demands/{id}' without encoding the id. One place now.

import { get, post, put, demandPath } from "./http";

export async function listDemands({ stage, status, businessOwner, limit = 100 } = {}) {
  return get("/demands/list", {
    query: { stage, status, business_owner: businessOwner, limit },
  });
}

export async function getDemand(demandId) {
  return get(demandPath(demandId));
}

export async function getDemandStats() {
  return get("/demands/stats/summary");
}

/** Cross-stage status view: which stages have produced a result, plus SN link state. */
export async function getDemandStatus(demandId) {
  return get(demandPath(demandId, "/status"));
}

export async function getClarifyTasks(demandId) {
  return get(demandPath(demandId, "/clarifybot-tasks"));
}

export async function updateDemand(demandId, payload) {
  return put(demandPath(demandId), payload);
}

/**
 * Set a demand's stage directly. Accepts any string — prefer advanceDemand().
 *
 * This is how values no screen filter matched ('ENHANCED_DISCOVERY',
 * 'AI_REQUIREMENTS') got into the table in the first place.
 */
export async function updateDemandStage(demandId, currentStage, stageStatus = "IN_PROGRESS") {
  return put(demandPath(demandId, "/stage"), {
    current_stage: currentStage,
    stage_status: stageStatus,
  });
}

/**
 * Move a demand forward one stage. -> { from, to, skippedPoc, message }
 *
 * The sanctioned transition: the server validates the target is genuinely ahead of
 * the current stage, skips POC when Discovery didn't call for one, and records an
 * audit event. Pass `to` to jump further ahead; backwards moves are refused (409).
 */
export async function advanceDemand(demandId, { to, note, actor = "System" } = {}) {
  return post(demandPath(demandId, "/advance"), { to, note, actor });
}
